<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <b-container>
    <div v-show="step1" class="slideshow-container">
      <div class="row">
        <div class="col-md-7">
          <div class="right_eugene">
            <p>
              Bonjour ! Moi, c’est Eugène Arnaud, chef du Jamboree, enchanté! Je suis un peu occupé, je suis en train
              d'ajuster le planning du rassemblement. Vous pouvez jeter un œil si vous voulez.
            </p>
            <div class="arrowright"></div>
          </div>
          <div class="right_eugene">
            <p>
              Vous cherchez tout ça ? Hmmm. J'ai un sextant, que je pourrais vous offrir. Mais c’est un objet précieux,
              pour les gens qui ont envie de parcourir le monde. D’ailleurs vous savez que ce ballon gigantesque
              représente la terre et tous ses pays?! Il fait 12 mètres de haut, on va s’en servir pour la cérémonie de
              clôture !! Pardon, je m’égare, c’est l’enthousiasme... Alors, pour ce sextant … Vous, est-ce que vous
              connaissez bien le monde ? On va voir cela !
            </p>
            <div class="arrowright"></div>
          </div>

          <div class="object" v-on:click="defi"><p>Relever le défi</p></div>
          <div class="dl">
            <a class="link" href="https://cdn.exploreve.fr/content/IM2/programme.png" target="_blank"
              ><p>Si tu es curieux·se, va découvrir le programme du Jamboree de 1947 par ici !</p></a
            >
          </div>
        </div>
        <div class="col-md-5">
          <div class="eugene">
            <img src="https://cdn.exploreve.fr/content/cluedo/Eugene.svg" height="400px" />
          </div>
          <div class="ballon">
            <img src="https://cdn.exploreve.fr/content/cluedo/ballon-monde.svg" height="300px" />
          </div>
        </div>
      </div>
    </div>
    <div v-show="step2" class="slideshow-container">
      <div v-if="score != 8" class="row justify-content-end" style="padding: 10px;">
        <div class="col-md-5">
          <draggable
            :list="shuffleListCountries"
            group="game"
            @start="drag = true"
            @end="drag = false"
            :disabled="true"
          >
            <div v-for="element in shuffleListCountries" :key="element.id">
              <div class="row justify-content-start">
                <BCard class="game-card-country">{{ element.country }}</BCard>
                <draggable
                  :list="element.placedCapital"
                  group="game"
                  @start="drag = true"
                  @end="drag = false"
                  :disabled="element.placedCapital.length >= 1"
                  class="game-ballongeant-trou"
                >
                  <div
                    v-for="subElement in element.placedCapital"
                    :key="subElement.id"
                    class="game-card-placed-wrapper"
                  >
                    <BCard
                      class="game-card game-card-placed row justify-content-end"
                      v-if="element.id == subElement.id"
                      bg-variant="success"
                      text-variant="white"
                      >{{ subElement.capital }}</BCard
                    >
                    <BCard
                      class="game-card game-card-placed row justify-content-end"
                      v-else
                      bg-variant="danger"
                      text-variant="white"
                    >
                      {{ subElement.capital }}
                      <b-icon-x-circle @click="removeElement(element)" style="font-size: 0.8em;" />
                    </BCard>
                  </div>
                </draggable>
              </div>
            </div>
          </draggable>
        </div>
        <div class="col-md-3" style="justify-content: start; display: flex;">
          <draggable :list="listCountries" group="game" @start="drag = true" @end="drag = false">
            <div v-for="element in listCountries" :key="element.id">
              <BCard class="game-card">{{ element.capital }}</BCard>
            </div>
          </draggable>
        </div>
        <div class="col-md-4">
          <div class="left short">
            <p>
              Voilà mon défi ! Déplace les capitales en face du pays qui lui correspond. Si tu réussis, je te donnerais
              mon sextant.
            </p>
            <div class="arrowbot"></div>
          </div>
          <div style="position: absolute; bottom: 20px; right: 50px;">
            <img src="https://cdn.exploreve.fr/content/cluedo/Eugene.svg" height="300px" />
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-md-8">
            <div style="margin: auto; text-align: center;">
              <img src="https://cdn.exploreve.fr/content/cluedo/Sextan.svg" height="400px" />
            </div>
            <div class="object" @click="closeModal()">
              <p>Récupérer le sextan</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="right" style="position: relative; right: 100px;">
              <p>Bravo ! Voilà le sextant. Je compte sur toi pour en prendre soin, c’est un objet précieux.</p>
              <div class="arrowbot" style="top: 58px;"></div>
            </div>
            <div style="position: absolute; bottom: 20px; right: 50px;">
              <img
                src="https://cdn.exploreve.fr/content/cluedo/Eugene.svg"
                height="300px"
                style="position: relative; right: 100px;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>
<style>
.short {
  max-width: 300px !important;
  padding-left: 10px !important;
}

.eugene {
  z-index: 2;
  position: relative;
}

.ballon {
  position: relative;
  z-index: 0;
  top: -350px;
  left: 80px;
}

.arrowbot {
  content: "";
  width: 0px;
  height: 0px;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid white;
  position: relative;
  top: 100px;
  left: -100px !important;
}

.right_eugene {
  font-family: "Faune";
  display: table;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  margin: 20px;
  max-width: 480px;
  width: intrinsic; /* Safari/WebKit utilisent un nom non-standard */
  width: -moz-max-content; /* Firefox/Gecko */
  width: -webkit-max-content;
  padding-right: 0px;
  margin-right: 10px;
  margin-left: auto;
}
a.link {
  color: #cd8c31 !important;
  cursor: pointer;
}

.dl {
  width: 60%;
  margin: auto;
  text-align: center;
  margin-top: 10px;
}

.dl:hover {
  text-decoration: underline;
}
.game-card-country {
  text-align: center;
  margin: 5px;
  font-size: 20px;
  height: 50px;
  width: 180px;
  background-color: #cd8c31;
  color: white;
  font-family: "Faune";
}
.game-card {
  margin: 5px;
  text-align: center;
  font-size: 20px;
  height: 50px;
  width: 250px;
  color: white;
  background-color: #cd8c31;
  font-family: "Faune";
}
.game-card.game-card-placed {
  width: 100%;
}
.game-card-placed-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-body {
  padding: 8px;
}
h5 {
  font-family: "Faune";
  font-size: 25px;
}
.modal-content {
  /* background-image: url("https://cdn.exploreve.fr/content/carte/rosedesvents.svg"); */
  background-color: #fbead3;
  background-repeat: no-repeat;
  background-position: 100% 150px;
}

.game-ballongeant-trou {
  height: 58px;
  width: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0px 0px 10px -8px #000;
  border: 3px solid #fbead3;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  border-radius: 5px;
}
</style>
<script>
import draggable from "vuedraggable";
import countries from "@/components/immersion02/Cluedo/Country";

export default {
  components: {
    draggable
  },
  data() {
    return {
      listCountries: [],
      shuffleListCountries: [],
      countries: countries,
      step1: true,
      step2: false,
      step3: false
    };
  },
  mounted() {
    this.fetchListCountries();
    this.fetchShuffleListCountries();
  },
  computed: {
    score: function () {
      let score = 0;
      this.shuffleListCountries.forEach((country) => {
        if (country && country.placedCapital && country.placedCapital[0] && country.placedCapital[0].id == country.id) {
          score++;
        }
      });
      if (score === 8) {
        this.$emit("recupObject", "sextant");
      }
      return score;
    }
  },
  methods: {
    defi() {
      this.step1 = false;
      this.step2 = true;
    },
    removeElement(root) {
      this.listCountries.push(root.placedCapital.pop());
    },
    fetchListCountries: function () {
      let result = [];
      for (let i = 0; i < 8; i++) {
        let rand = Math.floor(Math.random() * this.countries.length);
        //avoid repetition
        while (result.find((el) => this.countries[rand].name == el.country)) {
          rand = Math.floor(Math.random() * this.countries.length);
        }
        result.push({
          id: i,
          country: this.countries[rand].name,
          capital: this.countries[rand].capital,
          placedCapital: []
        });
      }
      this.listCountries = result;
    },

    /**
     * shuffle an array by Fisher–Yates  algorithm
     */
    fetchShuffleListCountries: function () {
      let clone = this.listCountries.slice();
      let j, x, i;
      for (i = clone.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = clone[i];
        clone[i] = clone[j];
        clone[j] = x;
      }
      this.shuffleListCountries = clone;
    },
    closeModal: function () {
      this.$emit("closeModal");
    }
  }
};
</script>
